export const ELECTRIC_CONSUMPTION_REPORT_ITEMS_FETCH =
  'ELECTRIC_CONSUMPTION_REPORT_ITEMS_FETCH';
